import { type ReactElement, type ReactNode } from 'react';
import { useTranslation } from 'next-i18next';

// Design System
import { Font } from '@utmb/design-system/text/font';
// Contexts
import { useUser } from '@utmb/contexts/AuthContext';
// Types
import { ColorTypesEnum } from '@utmb/types/colors';
// Utils
import { getColorStyle } from '@utmb/utils/colors';
// Styles
import styles from './login-blur.module.scss';

export interface LoginBlurProps {
    // The content is only a placeholder while blurred
    isBlurred: boolean;
    children: ReactNode;
}

// Blurs content reserved to logged in users, with a button to log in over it
export function LoginBlur({ isBlurred, children }: LoginBlurProps): ReactElement {
    const { t } = useTranslation();
    const { isAuthenticated, login } = useUser();

    return (
        <div className={styles.loginBlur}>
            <div className={isBlurred ? styles.blurred : undefined} aria-hidden={isBlurred}>
                {children}
            </div>
            {/* Once logged in, the content may still be loading */}
            {isBlurred && !isAuthenticated && (
                <button type="button" className={styles.loginButton} onClick={login}>
                    <Font.OxaniumMedium desktop="20" mobile="16" color={getColorStyle(ColorTypesEnum.WS_PRIMARY)}>
                        {t('singleRunner.resultsTable.connectSeeIndex')}
                    </Font.OxaniumMedium>
                </button>
            )}
        </div>
    );
}
